import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    RadioButton,
} from "client/components"

const Form = () => {
    const template = useSelector((state: StoreType) => state.rrsTemplate.templateEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={template.name} readOnly />
                    </FormGroup>
                    {
                        !project.id && (
                            <FormGroup>
                                <Label>{lang.default}</Label>
                                <FormGroup inline>
                                    <RadioButton
                                        checked={template.default}
                                        title={lang.yes}
                                        readOnly
                                    />
                                    <RadioButton
                                        checked={!template.default}
                                        title={lang.no}
                                        readOnly
                                    />
                                </FormGroup>
                            </FormGroup>
                        )
                    }
                    {
                        userData.accountId !== 1 && (
                            <FormGroup>
                                <Label>{lang.locked}</Label>
                                <FormGroup inline>
                                    <RadioButton
                                        checked={template.locked}
                                        title={lang.yes}
                                        readOnly
                                    />
                                    <RadioButton
                                        checked={!template.locked}
                                        title={lang.no}
                                        readOnly
                                    />
                                </FormGroup>
                            </FormGroup>
                        )
                    }
                    <FormGroup>
                        <Label>{lang.singleRiskMap}</Label>
                        <FormGroup inline>
                            <RadioButton
                                checked={template.singleRiskMap}
                                title={lang.yes}
                                readOnly
                            />
                            <RadioButton
                                checked={!template.singleRiskMap}
                                title={lang.no}
                                readOnly
                            />
                        </FormGroup>
                    </FormGroup>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
